import React, {useState, useEffect, useRef} from "react"
import autoResize from "../Scripts/autoResizeCreate"
import handleChange from "../Scripts/handleChangeCreate"
import CreateResource from "./CreateResource"

function CreateStep(props) {

    const overviewRef = useRef()
    const overviewCountRef = useRef()
    const [overview, setOverview] = useState({value: '', last: '', max: 128})
    const detailsRef = useRef()
    const detailsCountRef = useRef()
    const [details, setDetails] = useState({value: '', last: '', max: 500})
    const [resourceKey, setResourceKey] = useState(0)
    const resource = {key: resourceKey, resource: '', url: ''}
    const [resources, setResources] = useState([])

    const addResource = () => {
        setResourceKey(resourceKey + 1)
    }

    const removeResource = (index) => {
        if (resources.length > 0) setResources((prev) => prev.filter((_, i) => i !== index))
    }

    useEffect(() => {
        autoResize(overviewRef, overview.value, overview.last)
        autoResize(detailsRef, details.value, details.last)
        props.setSteps((prev) => {
            const updated = [...prev]
            updated[props.index] = {key: props.stepKey, overview: overview.value, details: details.value, resources: resources}
            return updated
        })
    }, [overview, details, resources])

    useEffect(() => {
        if (resourceKey != 0) setResources((prev) => [...prev, resource])
    }, [resourceKey])
	
    return (
        <div className="createstep">
            <textarea ref={overviewRef} className="createinput createoverview" placeholder="heading..." onChange={(e) => {handleChange(e.target.value, "step", overviewRef, overviewCountRef, overview, setOverview)}}></textarea>
            <p ref={overviewCountRef} className="charcount">{overview.value.length}/{overview.max}</p>
            <textarea ref={detailsRef} className="createinput createdetails" placeholder="details..." onChange={(e) => {handleChange(e.target.value, "step", detailsRef, detailsCountRef, details, setDetails)}}></textarea>
            <p ref={detailsCountRef} className="charcount">{details.value.length}/{details.max}</p>
            {resources.map((resource, index) => <CreateResource key={resource.key} resourceKey={resource.key} index={index} setResources={setResources} removeResource={removeResource}/>)}
            <button className="addresource" onClick={addResource}>+ resource</button>
            <button className="removestep" onClick={(index) => props.removeStep(props.index)}>- step</button>
        </div>
        
    )
}

export default CreateStep
